export default __webpack_public_path__ + "static/media/element_spec_23.07ccc42c.webp";